import * as React from 'react';

import { useIntl } from 'react-intl';

import ProfileLayout from 'src/features/profile/components/ProfileLayout';
import ProfileSettingsForm from 'src/features/profile/components/ProfileSettingsForm';
import { profileMessages, settingsMessages } from 'src/features/profile/utils/messages';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import { useTitleStore } from 'src/stores/useTitleStore';

const Settings = () => {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(profileMessages.title));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <ProfileLayout>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(settingsMessages.settingsTitle)}</SectionBlockTitle>
                        <SectionBlockSubtitle>{formatMessage(settingsMessages.settingsSubtitle)}</SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className="flex-col">
                    <ProfileSettingsForm />
                </SectionBlockBody>
            </SectionBlock>
        </ProfileLayout>
    );
};

export default Settings;
